// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, { Component } from 'react';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';

class CFCMAside extends Component {

    handleAsideTextChange = event => {

        this.props.handleAsideTextChange( event );

    };

    handleDropDownChange = id => {

        this.props.handleAsideCompFactoryDropdown( id );

    };

    render () {

        return (
            <section>
                {!this.props.isEdit &&
                    <div className="select-row-update">Select Row To Update</div>}

                {this.props.isEdit && (
                    <div>
                        {!this.props.isAdd && (
                            <LabeledInput
                                className="input-name"
                                isEditable={true}
                                disabled={true}
                                label="Component Factory"
                                name="componentFactoryCode"
                                maxLength={2}
                                value={this.props.componentpartNumber.componentFactoryCode}
                            />
                        )}
                        {this.props.isAdd && (
                            <OptionsDropDown
                                className="input-name"
                                label="Component Factory"
                                name="componentFactoryCode"
                                isPlaceholderTranslated={true}
                                onChange={this.handleDropDownChange}
                                optionDisplayAttributes={['factoryDescription']}
                                optionKey="factoryCode"
                                options={this.props.componentDropdownList}
                                placeholder=""
                                selectedValue={this.props.value}
                                isRequired={true}
                            />
                        )}
                        <LabeledInput
                            className="input-name"
                            isEditable={true}
                            label="Component Part No"
                            name="componentPartNumber"
                            maxLength={12}
                            onChange={this.handleAsideTextChange}
                            value={this.props.componentpartNumber.componentPartNumber}
                            isRequired={true}
                            disabled={!this.props.isAdd}
                        />
                        <LabeledInput
                            className="input-name"
                            isEditable={true}
                            label="Manufacturing Factory"
                            name="manufacturingFactoryCode"
                            maxLength={2}
                            onChange={this.handleAsideTextChange}
                            value={this.props.componentpartNumber.manufacturingFactoryCode}
                        />
                        <LabeledInput
                            className="input-name"
                            isEditable={true}
                            label="Model Code"
                            name="model"
                            maxLength={5}
                            onChange={this.handleAsideTextChange}
                            value={this.props.componentpartNumber.model}
                        />
                        <LabeledInput
                            className="input-name"
                            isEditable={true}
                            label="Component Function Code"
                            name="componentFunctionCodeName"
                            maxLength={7}
                            onChange={this.handleAsideTextChange}
                            value={this.props.componentpartNumber.componentFunctionCodeName}
                            isRequired={true}
                        />
                        <LabeledInput
                            className="input-name"
                            isEditable={true}
                            label="Component Group Code"
                            name="componentGroupCode"
                            maxLength={20}
                            onChange={this.handleAsideTextChange}
                            value={this.props.componentpartNumber.componentGroupCode}
                        />
                    </div>
                )}
                {this.props.isEdit && !this.props.isAdd && (
                    <div className="button-align">
                        <button className="close-button" type="button" onClick={this.props.onDelete}>
                            <span> Delete </span>
                        </button>
                        <button
                            className="primary-button"
                            type="button"
                            onClick={this.props.onUpdate}
                            disabled={!( ( this.props.componentpartNumber.componentPartNumber !== undefined && ( this.props.componentpartNumber.componentPartNumber ).trim() !== '' )
                            && ( this.props.componentpartNumber.componentFunctionCodeName !== undefined && ( this.props.componentpartNumber.componentFunctionCodeName ).trim() !== '' ) )}
                        >
                            <span> Update </span>
                        </button>
                    </div>
                )}
                {this.props.isAdd && (
                    <div className="button-align">
                        <button className="close-button" type="button" onClick={this.props.onCancel}>
                            <span> Cancel </span>
                        </button>
                        <button
                            className="primary-button"
                            type="button"
                            onClick={this.props.onUpdate}
                            disabled={!( ( this.props.componentpartNumber.factoryCode !== undefined && this.props.componentpartNumber.factoryCode !== '-1' )
                            && ( this.props.componentpartNumber.componentPartNumber !== undefined && ( this.props.componentpartNumber.componentPartNumber ).trim() !== '' )
                            && ( this.props.componentpartNumber.componentFunctionCodeName !== undefined && ( this.props.componentpartNumber.componentFunctionCodeName ).trim() !== '' ) )}
                        >
                            <span> Add New </span>
                        </button>
                    </div>
                )}
            </section>
        );

    }

}
CFCMAside.displayName = 'CFCMAside';
CFCMAside.propTypes = {
    componentpartNumber: PropTypes.object.isRequired,
    componentDropdownList: PropTypes.array.isRequired,
    isEdit: PropTypes.bool.isRequired,
    isAdd: PropTypes.bool.isRequired,
    value: PropTypes.string,
    onCancel: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    handleAsideTextChange: PropTypes.func,
    handleAsideCompFactoryDropdown: PropTypes.func,
};

export default CFCMAside;
